import Box from 'components/shared/Box'
import styled from 'styled-components'
import { fadeInOnRender } from 'styles/animations'
import { respondAbove } from 'styles/mediaQueries'

export const Wrapper = styled(Box)`
    width: 100%;
    padding: 16px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.grayscale_100};
    border: 2px solid ${({ theme }) => theme.colors.grayscale_300};
    ${fadeInOnRender};

    @media ${respondAbove.lg} {
        padding: 32px 40px;
    }
`
